import { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { addDemoQueryData } from "../../../../redux/actions/API/demoQueryAction";
import { notification, Form, Input, Select, Button } from "antd";
import Loader from "../../../Loader/Loader";

const { Option } = Select;

interface IFormData {
  name: string;
  phone: string;
  company: string;
  turnover: string;
  sector: string;
  email: string;
}

interface IFreeTrialFormProps {
  addDemoQueryData: (payload: any) => void;
  addDemoQueryDataState: {
    loading: boolean;
    error?: any;
    data?: { message?: string };
  };
}

const FreeTrialForm: React.FC<IFreeTrialFormProps> = ({
  addDemoQueryData,
  addDemoQueryDataState,
}) => {
  const [loading, setLoading] = useState(false);
  const prevPropsRef = useRef<IFreeTrialFormProps | null>(null);
  const [form] = Form.useForm();

  const openNotificationWithIcon = (
    type: "success" | "error" | "info" | "warning",
    message: string
  ) => {
    notification.open({
      message,
      type,
      duration: 3,
    });
  };

  useEffect(() => {
    if (
      prevPropsRef.current?.addDemoQueryDataState?.loading &&
      !addDemoQueryDataState.loading
    ) {
      if (addDemoQueryDataState.error) {
        openNotificationWithIcon(
          "error",
          "Something went wrong. Please try again later!"
        );
        setLoading(false);
      } else {
        form.resetFields();
        openNotificationWithIcon(
          "success",
          addDemoQueryDataState?.data?.message || "Submitted successfully!"
        );
        setLoading(false);
      }
    }
    prevPropsRef.current = { addDemoQueryData, addDemoQueryDataState };
  }, [addDemoQueryDataState]);

  const handleSubmit = (values: IFormData) => {
    const payload = {
      fullName: values.name,
      phone: values.phone,
      companyName: values.company,
      industry: values.sector,
      email: values.email,
      turnover: values.turnover,
      companyWebsite: null,
      companySize: null,
      currentERP: null,
      modules: null,
      query: null,
      source: "Free Trial Form",
      ip_address: null,
    };
    setLoading(true);
    addDemoQueryData(payload);
  };

  return (
    <div className="bg-white shadow-lg rounded-xl px-4 py-3 w-full ">
      <Loader loading={loading} />
      <h2 className="text-xl font-bold mb-3 text-center text-[#1677ff]">
        Request a Demo
      </h2>

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          name: "",
          phone: "",
          email: "",
          company: "",
          turnover: "",
          sector: "",
        }}
      >
        <Form.Item
          name="name"
          label="Full Name"
          rules={[{ required: true, message: "Please enter your full name" }]}
        >
          <Input placeholder="Full Name*" />
        </Form.Item>

        <Form.Item
          name="phone"
          label="Phone Number"
          rules={[
            { required: true, message: "Enter your phone number" },
            { pattern: /^[6-9]\d{9}$/, message: "Enter a valid 10-digit number" },
          ]}
        >
          <Input placeholder="Phone Number*" />
        </Form.Item>

        <Form.Item
          name="company"
          label="Company Name"
          rules={[{ required: true, message: "Please enter company name" }]}
        >
          <Input placeholder="Company Name*" />
        </Form.Item>

        <Form.Item
          name="email"
          label="Email Address"
          rules={[{ type: "email", message: "Enter a valid email" }]}
        >
          <Input placeholder="Email (Optional)" />
        </Form.Item>



        {/* <Form.Item
          name="sector"
          label="Sector"
          rules={[{ required: true, message: "Please select a sector" }]}
        >
          <Select placeholder="Select Sector">
            <Option value="manufacturing">Manufacturing</Option>
            <Option value="trading">Trading</Option>
            <Option value="others">Others</Option>
          </Select>
        </Form.Item> */}


        {/* <Form.Item
          name="turnover"
          label="Company Turnover"
          rules={[{ required: true, message: "Please select company turnover" }]}
        >
          <Select placeholder="Select Turnover">
                      <Option value="1-10">Less than 10Cr</Option>
                      <Option value="10-20">10Cr-20Cr</Option>
                      <Option value="20-50">20Cr-50Cr</Option>
                      <Option value="50-100">50Cr- 100 Cr</Option>
                      <Option value="100+">More than 100 Cr</Option>
          </Select>
        </Form.Item> */}


        <Button
          type="primary"
          htmlType="submit"
          block
          className="bg-[#1677ff] hover:bg-[#4096ff]"
        >
          Request a Demo
        </Button>
      </Form>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  addDemoQueryDataState: state.api.addDemoQueryData,
});

const mapDispatchToProps = (dispatch: any) => ({
  addDemoQueryData: (payload: any) => dispatch(addDemoQueryData(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FreeTrialForm);
